// Static image imports for webpack bundling
import bers from "./images/berscom-screenshot.png";
import kbcmall from "./images/kbcmall.com-screenshot.png";
import tinypdf from "./images/tinypdfconvertor-screenshot.png";
import vticc from "./images/vticc-screenshot.png";
import kaphy from "./images/kaphyinsurance-screenshot.png";
import maisystem from "./images/maisystem-screenshot.png";
import timelypays from "./images/timelypays-screenshot.png";
import primestaffworks from "./images/primestaffworks-screenshot.png";
import mwcconnections from "./images/mwcconnections-screenshot.png";
import reviewsnap from "./images/reviewsnap-screenshot.png";
import safecare from "./images/safecarehomesmn-screenshot.png";
import soleiman from "./images/soleimaninsurance-screenshot.png";
import epaymoneytrasnfer from "./images/epay-money-transfer-screenshot.png";
import vastburgers from "./images/vast-burgers-screenshot.png";

const imageMap = {
  "images/berscom-screenshot.png": bers,
  "images/kbcmall.com-screenshot.png": kbcmall,
  "images/tinypdfconvertor-screenshot.png": tinypdf,
  "images/vticc-screenshot.png": vticc,
  "images/kaphyinsurance-screenshot.png": kaphy,
  "images/maisystem-screenshot.png": maisystem,
  "images/timelypays-screenshot.png": timelypays,
  "images/primestaffworks-screenshot.png": primestaffworks,
  "images/mwcconnections-screenshot.png": mwcconnections,
  "images/reviewsnap-screenshot.png": reviewsnap,
  "images/safecarehomesmn-screenshot.png": safecare,
  "images/soleimaninsurance-screenshot.png": soleiman,
  "images/epay-money-transfer-screenshot.png": epaymoneytrasnfer,
  "images/vast-burgers-screenshot.png": vastburgers,
};

export const getProjectImage = (imagePath) => imageMap[imagePath] || null;

export default imageMap;
